module.exports = __webpack_public_path__ + "img/5.96346dce.png";